
export const routes = {

  //------------------------------------------------------------
  // Third party authentication

  googleAuthVerify:       () => `/auth/google-verify`,

  //------------------------------------------------------------
  // Getting started

  home:                   (tid?: string) => tid
                            ? `/t/${tid}`
                            : '/',
  logIn:                  (tid?: string) => tid
                            ? `/t/${tid}/log-in`
                            : '/log-in',
  logOut:                 (tid?: string) => tid
                            ? `/t/${tid}/log-out`
                            : '/log-out',

  //------------------------------------------------------------
  // Tenant pages

  tenantEdit:             (tid: string) => `/t/${tid}/edit`,

  tenantInvoices:         (tid: string) => `/t/${tid}/billing/invoice`,

  feedView:               (tid: string, fid: string) => `/t/${tid}/feed/${fid}/view`,
  feedEdit:               (tid: string, fid: string) => `/t/${tid}/feed/${fid}/edit`,

  //------------------------------------------------------------
  // Admin pages

  admin:                  () => `/admin`,

  adminKbArticles:        () => `/admin/kb/article`,
  adminKbArticleNew:      () => `/admin/kb/article/new`,
  adminKbArticleEdit:     (id: string) => `/admin/kb/article/${id}`,
  adminKbAgent:           () => `/admin/kb/agent`,

  adminUsers:             () => `/admin/user`,
  adminUserEdit:          (id: string) => `/admin/user/${id}`,
  adminWebHits:           () => `/admin/web-hit`,
  adminIcons:             () => `/admin/misc/icons`,

}
